const commonHu = {
    "max_8_tags": "Legfeljebb 8 címkét választhatsz ki.",
    "max_8_tags_hint": "Maximum 8 címke választható ki.",
    "refund_success": "Sikeres visszatérítés!",
    "refund_failed": "Sikertelen visszatérítés!",
    "extra_column": "Plusz üres oszlop a végén",
    "print": "Nyomtatás",
    "save_as_pdf": "Mentés PDF-be",
    "id": "Azonosító",
    "confirm": "Megerősít",
    "cancel": "Mégse",
    "delete": "Törlés",
    "deleted": "Törölve",
    "view": "Megtekintés",
    "actions": "Műveletek",
    "details": "Részletek",
    "reservation_type": "Foglalás típusa",
    "close": "Bezárás",
    "more_info": "További információ",
    "next": "Következő",
    "refund": "Visszatérítés",
    "previous": "Előző",
    "show_x_out_of_x": "{{count}} mutatása {{maxCount}}-ből",
    "guest": "Vendég",
    "guests": "Vendégek",
    "search": "Keresés",
    "refund_question": " Biztosan visszatérítést szeretnél végrehajtani? Ez a művelet nem vonható vissza.",
    "name": "Név",
    "email": "Email",
    "phone": "Telefon",
    "reservations": "Foglalások",
    "note": "Megjegyzés",
    "notes": "Megjegyzések",
    "save": "Mentés",
    "download": "Letöltés",
    "download_csv": "Letöltés (CSV)",
    "marketing_consent": "Marketing hozzájárulás",
    "domestic": "Belföldi",
    "foreign": "Külföldi",
    "country": "Ország",
    "seat": "fő",
    "day": "Nap",
    "add": "Hozzáadás",
    "add_new": "Új hozzáadása",
    "edit": "Szerkesztés",
    "no_data": "Nincs adat",
    "language": "Nyelv",
    "languages": {
        "en": "Angol",
        "hu": "Magyar",
        "ru": "Orosz",
        "de": "Német",
        "fr": "Francia",
        "es": "Spanyol",
        "it": "Olasz",
        "sk": "Szlovák",
        "uk": "Ukrán",
        "hr": "Horvát",
        "he": "Héber",
    },
    "no_selected": "Nincs kiválasztva",
    "selected": "kiválasztva",
    "lunch": "Ebéd",
    "dinner": "Vacsora",
    "afternoon": "Délután",
    "table": "Asztal",
    "tables": "Asztalok",
    "internal_note": "Belső megjegyzés",
    "date": "Dátum",
    "select_daterange": "Dátum(ok) kiválasztása",
    "time_date": "Időpont",
    "duration": "Időtartam",
    "reservation": "Foglalás",
    "all": "Összes",
    "note_detailed": "Megjegyzés részletes leírása",
    "valid_from": "Érvényesség kezdete",
    "valid_from_time": "Érvényesség kezdete (idő)",
    "valid_to": "Érvényesség vége",
    "valid_to_time": "Érvényesség vége (idő)",
    "copy": "Másolás",
    "copied_to_clipboard": "Vágólapra másolva",
    "select_file": "Fájl kiválasztása",
    "link": "Link",
    "query": "Lekérés",
    "payments": "Pénzügyek",
    "status": "Státusz",
    "commission": "Jutalék",
    "amount_paid": "Fizetett összeg",
    "sms_fee_amount_net": "SMS díja (nettó)",
    "file_name": "Fájlnév",
    "date_interval": "Idő intervallum",
    "previous_month": "Előző hónap",
    "month": "Hónap",
    "comparison_mode": "Mód",
    "full_month": "Teljes hónap",
    "to_date": "Mai napig",
    "full_month_warning": "A hónap még nem ért véget, ezért a teljes hónapos összehasonlítás félrevezető lehet. Válaszd a „Mai napig” módot az azonos időszakok összevetéséhez.",
    "phone_number": "Telefonszám",
    "titles": {
        "group_reservation_details": "Csoportos ajánlat részletei",
        "main_title": "ReservOurs Admin",
        "reservations": "Táblázatos",
        "events": "Események",
        "payments": "Pénzügyek",
        "guests": "Vendégadatbázis",
        "settings": "Beállítások",
        "knowledge_base": "Tudásbázis",
        "reservation_time_table": "Idősávos",
        "table_planner": "Asztaltérkép",
        "giftcards": "Ajándékutalványok",
        "group_reservation": "Csoportos ajánlatok",
        "waitlist": "Várólista",
        "group_reservation_edit": "Csoportos foglalás szerkesztése",
        "statistics": "Statisztikák",
        "not_found": "Az oldal nem található",
        "logout": "Kijelentkezés",
        "login": "Bejelentkezés",
        "password_reset": "Jelszó visszaállítása",
        "registration": "Regisztráció",
        "floor_plan_designer": "Asztaltérkép tervező",
    },
    "page_not_found": "Az oldal nem található",
    "not_found_description": "Kérjük ellenőrizze az URL-t, vagy térjen vissza a főoldalra.",
    "back_to_home": "Vissza a főoldalra",
    "richtext_placeholder": "Írja ide a szöveget...",
    "person_amount": "fő",
    "no_results": "Nincs találat",
    "no_data_to_display": "Nincs megjelenítendő adat",
    "labels": "Címkék",
    "save_guest_info": "Vendég adatok mentése",
    "cancelled_reservations": "Lemondott foglalások",
    "guest_info_updated": "Vendég adatai frissítve",
    "currency": "Pénznem",
    "select": "Kiválaszt",
    "not_set": "Nincs beállítva",
    "yes": "Igen",
    "no": "Nem",
    "saved_successfully": "Sikeresen mentve",
    "deleted_successfully": "Sikeresen törölve",
    "select_to_edit": "Válassz ki egy sort a szerkesztéshez",
    "type": "Típus",
    "no_more_available_labels": "Nincs több elérhető címke",
    "closed": "Zárva",
    "logout": "Kijelentkezés",
    "hour": "Óra",
    "invalid_value": "Érvénytelen érték",
    "invalid_date_range": "Érvénytelen dátumtartomány",
    "field_required": "A mező kitöltése kötelező",
    "file_too_large": "A fájl túl nagy (max 2MB)",
    "file_is_not_image_type": "A fájl nem kép típusú",
    "for_minutes": "percre",
    "send_mail": "Email küldése",
    "email_template": "Email sablon",
    "send": "Küldés",
    "email_text": "Email szövege",
    "email_sent": "Email elküldve",
    "approve": "Jóváhagyás",
    "decline": "Elutasítás",
    "reset_form": "Űrlap visszaállítása",
    "back_to_list": "Vissza a listához",
    "send_sms": "SMS küldése",
    "sms_sent": "SMS elküldve",
    "no_reservations_to_show": "Nincs megjeleníthető foglalás",
    "time": "Idő",
    "statistics": "Statisztika",
    "reviews": "Értékelések",
    "length": "Hossz",
    "occasion": "Alkalom",
    "datatable_info": "Megjelenítve _START_ - _END_ a(z) _TOTAL_ bejegyzésből",
    "monthly_reservations": "Havi foglalási adatok",
    "message_template": "Üzenet sablon",
    "required_field": "Kötelező mező",
    "value_not_valid": "Érvénytelen érték",
    "warning": "Figyelmeztetés",
    "view_invoices": "Számlák megtekintése",
    "new_table": "Új asztal",
    "selected_table": "Kiválasztott asztal szerkesztése",
    "no_table_selected_tooltip": "Nincs asztal kiválasztva.",
    "table_name": "Asztal neve",
    "table_size": "Asztal mérete",
    "table_shape": "Asztal formája",
    "table_type": "Asztal típusa",
    "table_types": {
        "inside": "Beltéri",
        "outside": "Kültéri",
        "blocked": "Blokkolt"
    },
    "reservation_type_labels": {
        "inside": "Bent",
        "outside": "Kint",
        "blocked": "Blokkolt / Online nem foglalható"
    },
    "table_shapes": {
        "rectangle": "Téglalap",
        "circle": "Kör",
    },
    "changes_saved": "Változások mentve",
    "save_changes": "Változások mentése",
    "min_table_size": "Minimális asztal méret",
    "remove": "Eltávolítás",
    "remove_table": "Asztal eltávolítása",
    "remove_table_confirmation": "Biztosan el szeretné távolítani ezt az asztalt? A változtatások mentése után nem lesz lehetősége visszavonni a törlést.",
    "table_angle_label": "Asztal forgatása (°)",
    "sizes_by_table_types": "Férőhelyek asztal típusok szerint",
    "selected_table_by_table_types": "Férőhelyek asztal a kiválasztott teremben",
    "sizes_by_rooms": "Férőhelyek termek szerint",
    "table_count": "Asztalok száma",
    "table_size_space": "Férőhelyek",
    "room": "Terem",
    "announcements": "Közlemények",
    "voucher_uid": "Ajándékutalvány azonosító",
    "voucher_value": "Ajándékutalvány értéke",
    "voucher_used": "Felhasználva",
    "toggle_voucher_confirmation": "Biztosan módosítani szeretnéd a(z) {{voucherUid}} utalvány állapotát '{{state}}'-ra?",
    "used": "Felhasználva",
    "unused": "Nincs felhasználva",
    "mark_unused": "Megjelölés nem felhasználtként",
    "mark_used": "Megjelölés felhasználtként",
    "not_used": "Nincs felhasználva",
    "buyer_name": "Vásárló neve",
    "selling_date": "Eladás dátuma",
    "giftcard_search_ignores_date_interval": "A keresés minden ajándékutalványra lefut, az időszaktól függetlenül.",
    "giftcards_title": "Ajándékutalványok",
    "no_restaurant": "Nincs ilyen étterem",
    "paid": "fizetve",
    "coupon_code": "Kuponkód",
    "payment_in_progress": "fizetés folyamatban",
    "copy_display_order": "Megjelenítési sorrend másolása feltöltési sorrendhez",
    "deleted_by": "Törölte",
    "all_day": "Egész nap",
    "delete_guest_title": "Vendég törlése",
    "guest_delete_confirmation": "Biztosan törölni szeretné a vendéget? Ez a művelet nem vonható vissza.",
    "guest_deleted": "Vendég törölve",
    "guest_delete_error": "Törlés sikertelen",
    "guest_delete_not_allowed": "Jövőbeli foglalás esetén nem törölhető",
    "reservation_history": "Foglalási előzmények",
    "edit_merged_guest_data": "Összevont vendégadatok szerkesztése",
    "added_guest_data": "Hozzáadott vendég adat",
    "final_data": "Végleges adat",
    "merge_guests": "Vendégek összevonása",
    "merge_guests_confirmation": "Vendég egyesítés megerősítése",
    "new_guest_profile_data": "Új vendég profil adatai",
    "merge_guests_alert": "Vendégek egyesítése során az eddigi két vendég profil egyetlen profilba lesznek összevönva. Az új profil rendelkezni fog mindkét eddigi profil foglalási előzményeivel és adataival.",
    "process_can_not_be_reverted": "A folyamat nem fordítható vissza.",
    "merge_successful": "Összevonás sikeres",
    "todays_deletes": "Mai törölt foglalások",
    "possible_duplications": "Lehetséges duplikációk",
    "merge": "Összevonás",
    "seat_count": "Férőhelyek",
    "table_selection": "Asztal kiválasztása",
    "apply": "Alkalmaz",
    "map": "Térkép",
    "select_from_list": "Kiválasztás listából",
    "all_reservations": "Összes foglalás",
    "weekday": "Hét napja",
    "active": "Aktív",
    "inactivate": "Inaktiválás",
    "inactive": "Inaktív",
    "upload_file": "Fájl feltöltése",
    "uploaded_attachments": "Feltöltött csatolmányok",
    "no_attachments_uploaded": "Nincsenek még feltöltött csatolmányok",
    "no_image_selected": "Nincs kép kiválasztva",
    "select_image": "Kép kiválasztása",
    "upload_image": "Kép feltöltése",
    "handle_incomplete_data": "Hiányos adatok kezelése",
    "guests_without_names_count": "{{count}} név nélküli vendég",
    "guests_without_email_or_phone_count": "{{count}} email vagy telefonszám nélküli vendég",
    "auto_arrange_tables": "Asztalok automatikus rendezése",
    "back": "Vissza",
    "voucher_total_value": "Ajándékutalvány havi értéke",
    "total_value": "Teljes érték",
    "create": "Létrehozás",
    "previous_visits": "Korábbi látogatások",
    "no_consumption_data": "Ehhez a vendéghez nem áll rendelkezésre fogyasztási adat.",
    "load_more": "Tovább",
    "show_more": "Több mutatása",
    "show_less": "Kevesebb mutatása",
    "tip": "borravaló",
    "stats": {
        "daily_refresh_notice": "A statisztikai adatok naponta egyszer, éjszakánként frissülnek, ezért a foglalás adatok és a vendégadatbázis változásai csak később lesznek láthatóak ezen az oldalon.",
        "ntak_time_frames": {
            "last_week": "Az elmúlt hét",
            "last_month": "Az elmúlt hónap",
            "ninety_days": "Az elmúlt 90 nap",
            "last_6_months": "Az elmúlt 6 hónap"
        },
        "total_spent": "Összes költés",
        "total_tips": "Összes borravaló",
        "average_order_value": "Átlagos számla",
        "tip_ratio": "Borravaló arány",
        "payment_methods": {
            "KESZPENZHUF": "Készpénz (HUF)",
            "KESZPENZEUR": "Készpénz (EUR)",
            "SZEPKARTYA": "SZÉP kártya",
            "BANKKARTYA": "Bankkártya",
            "ATUTALAS": "Átutalás",
            "EGYEB": "Egyéb",
            "VOUCHER": "Ajándékutalvány",
            "SZOBAHITEL": "Szobahitel",
            "KEREKITES": "Kerekítés"
        },
        "event_count": "Összes esemény",
        "most_popular_dish": "Legnépszerűbb étel",
        "average_spending_per_guest": "Átlag költés / vendég",
        "average_tip_ratio_per_guest": "Átlag borravaló",
        "consumption_by_source": "Össz bevétel csatornánként",
        "avg_spending_per_guest": "Átlag bevétel/fő",
        "consumption_trends": "Átlagos költés/fő esemény típus szerint",
        "events": {
            "birthday": "Születésnap",
            "anniversary": "Évforduló",
            "rendezvous": "Randevú",
            "business_meal": "Üzleti ebéd",
            "celebration": "Ünneplés",
            "family_event": "Családi esemény",
            "friends_gathering": "Baráti összejövetel"
        },
        "returning_guest_spending": "Visszatérő vendégek aránya csatornánként",
        "returning_guest_note": "A diagramon azon vendégek szerepelnek, akiknek az étterembe tett első látogatása {{fromDate}} után volt esedékes.",
        "returning_guests_percent": "Visszatérő vendégek (%)",
        "money_spent_huf": "Elköltött összeg (HUF)",
        "top_items_by_event_type": "Legjellemzőbb tételek eseménytípus szerint",
        "items_by_popularity": "Tételek népszerűség szerint",
        "sort_by_quantity": "Rendelés szám szerint",
        "sort_by_spend": "Költés szerint",
        "quantity": "Mennyiség",
        "total_huf": "Összeg (Ft)",
        "reservation_count": "Foglalás szám",
        "avg_reservation_per_guest": "Átlagos költés/fő",
        "most_spending_guests": "Legtöbbet fogyasztó vendégek",
        "avg_spending_per_reservation": "Átlagos költés/foglalás",
        "sources": {
            "google": "Google",
            "facebook": "Facebook",
            "instagram": "Instagram",
            "tiktok": "TikTok",
            "website": "Weboldal",
            "reservours": "Reservours",
            "other": "Egyéb"
        }
    },
    "website": "Weboldal",
    "modified": "Módosítva",
    "value": "Érték",
    "giftcard_purchase_data": "Ajándékutalvány vásárlási adatok",
    "resend_email": "Email újraküldés",
    "purchased_vouchers": "Vásárolt utalványok",
    "save_buyer_data": "Vásárlói adatok mentése",
    "save_buyer_data_confirmation": "A módosítások az összes utalványra érvényesek lesznek, amelyek ebben a tranzakcióban szerepelnek, és az ajándékutalványok az új adatok alapján lesznek kereshetők. Biztosan folytatod?",
    "resend_email_confirmation": "Biztosan újra szeretnéd küldeni az ajándékutalványokat a vásárló email címére?",
    "save_failed": "Sikertelen mentés",
    "resend_success": "Sikeres újraküldés",
    "resend_failed": "Sikertelen újraküldés",
    "min_voucher_value": "Min. érték",
    "max_voucher_value": "Max. érték",
    "voucher_value_range_error": "Az értéknek {{min}} és {{max}} közé kell esnie",
    "voucher_sending_info": "Az utalvány a megadott email címre kerül majd kiküldésre",
    "send_voucher": "Utalvány küldése",
    "voucher_sent_successfully": "Utalvány sikeresen elküldve!",
    "internal_voucher_sending": "Belső utalvány küldése",
    "internal_voucher": "Belsős utalvány",
    "send_internal_voucher": "Belsős utalvány küldése",
    "display_text": "Megjelenített szöveg",
    "value_voucher": "Értékutalvány",
    "value_vouchers": "Értékutalványok",
    "chosen_voucher": "Választott utalvány",
    "experience_vouchers": "Élményutalványok",
    "created_at": "Létrehozva",
    "current": "Jelenlegi",
    "overwritten": "Felülírt"
}

export default commonHu;